export default "__VITE_ASSET__DMAV_eAA__"